const cities = [
  { name: "Islamorada", zips: "33036" },
  { name: "Key Largo", zips: "33037" },
  { name: "Tavernier", zips: "33070" },
  { name: "Marathon", zips: "33050" },
  { name: "Duck Key", zips: "33050" },
  { name: "Key West", zips: "33040" },
  { name: "Big Pine Key", zips: "33043" },
  { name: "Florida City", zips: "33034" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your Keys home, marina, or boat in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle the rest.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function IslamoradaLocalAreaSection() {
  return (
    <section id="service-area" className="bg-[#F7F8FA] pt-6 md:pt-8 pb-20 md:pb-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Islamorada &amp; the Florida Keys
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Whether you are in Islamorada, Key Largo, Tavernier, Marathon, Duck Key, or anywhere in the Florida Keys, Fast Passport Center makes expedited passport processing simple — as a registered courier, we have guaranteed submission availability at the Miami Passport Agency.
          </p>
        </div>

        {/* Full-width editorial intro */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 md:p-8 mb-12">
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Islamorada is unlike anywhere else in the United States. Nicknamed the "Village of Islands," this stretch of the Upper Florida Keys — spanning roughly 18 miles from Mile Marker 90 to Mile Marker 63 on U.S. Route 1, the Overseas Highway — is a world apart from mainland Florida. Where other coastal communities blend tourism with suburban development, Islamorada is a working waterfront community where sportfishing, diving, and marine life define daily existence. The turquoise waters of the Florida Bay meet the deep blue of the Atlantic Ocean here, creating a marine ecosystem that supports one of the most diverse fisheries in the Western Hemisphere.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            What makes Islamorada truly unique is its identity as the "Sportfishing Capital of the World." This is not marketing hyperbole — it is a designation earned through decades of world-record catches, legendary charter captains, and a fishing culture that permeates every aspect of local life. From the offshore waters where sailfish, marlin, and mahi-mahi run during winter and spring, to the shallow flats where bonefish and tarpon challenge even the most skilled anglers year-round, Islamorada offers fishing experiences that draw enthusiasts from every continent. The annual sailfish tournaments, tarpon tournaments, and offshore billfish competitions attract professional anglers, fishing guides, and tournament teams from the Bahamas, Costa Rica, Mexico, Australia, and beyond.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Beyond sportfishing, Islamorada is a gateway to some of the most extraordinary marine experiences in North America. The Florida Keys National Marine Sanctuary surrounds the islands, protecting coral reefs, seagrass beds, and mangrove ecosystems that support snorkeling, scuba diving, kayaking, and paddleboarding. Robbie's Marina, located at Mile Marker 77.5, is famous for its tarpon feeding experience — visitors hand-feed massive tarpon from the docks, an attraction that has drawn travelers from around the world for decades. The History of Diving Museum chronicles the evolution of underwater exploration, while the Theater of the Sea — one of the oldest marine mammal facilities in the world — offers dolphin and sea lion encounters that have been a Keys tradition since 1946.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            Islamorada's travel demographics reflect its unique position as both a destination and a departure point. Tournament anglers travel internationally for competitions — the Bahamas Wahoo Championship, the Costa Rica Offshore Championship, the Bisbee's Black & Blue Marlin Tournament in Cabo San Lucas. Diving enthusiasts head to Cozumel, Belize, and the Cayman Islands for reef and wreck diving. Charter captains and marine professionals rotate between fishing seasons in the Keys, the Bahamas, and Central America. Seasonal residents and snowbirds who own Islamorada waterfront properties often maintain international travel plans that sync with fishing seasons, dive trips, and family vacations in the Caribbean.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed mb-4">
            The geographic reality of Islamorada also shapes its passport challenges. Located approximately 80 miles south of Miami and 75 miles north of Key West, Islamorada is isolated by the very geography that makes it beautiful. The Overseas Highway — U.S. Route 1 — is the only road connecting the Keys to the mainland, and it is famously vulnerable to flooding, traffic congestion, and hurricane closures. A trip from Islamorada to the Miami Passport Agency requires driving the entire length of the Overseas Highway through Key Largo, Homestead, and Miami — a journey that can take two to three hours in normal traffic and significantly longer during peak season, accidents, or weather events. For an Islamorada charter captain who discovers an expired passport the week before a Bahamas tournament, that trip is not just inconvenient — it may be impossible given weather windows and fishing commitments.
          </p>
          <p className="text-gray-600 text-sm leading-relaxed">
            Fast Passport Center has processed expedited passports for Islamorada travelers across every Keys demographic — charter captains, tournament anglers, dive instructors, seasonal residents, and families heading to Caribbean cruises. We understand that an angler flying MIA to Nassau for a Wahoo Championship has the same urgency as a family of four leaving on a dive trip to Cozumel. Our courier-based expedited service means you start online from your Islamorada waterfront home, your marina office, or your favorite Keys tiki bar — and your passport arrives within days, not months.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {/* Left — FPC Office + How It Works */}
          <div>
            {/* FPC Office Card */}
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex flex-col xl:flex-row gap-6">
                <div className="flex-1">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-building-2-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Delray Beach</p>
                  <p className="text-white/60 text-xs mt-0.5">401 W Atlantic Ave #351, Delray Beach, FL 33444</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                Nearest office to Islamorada — approximately 110 miles north via Overseas Highway / I-95
              </p>
              <p className="text-white/50 text-xs mb-5 ml-5">Courier pickup available throughout Monroe County and the Florida Keys</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, choose what works best for you: <strong className="text-white">courier pickup</strong> from your home or Islamorada marina in most cases, <strong className="text-white">ship with our prepaid label</strong> from any UPS/FedEx location, or <strong className="text-white">schedule a drop-off</strong> at our Delray Beach office. Most clients ship overnight — no visit required.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

                {/* Map */}
                <div className="xl:w-[340px] flex-shrink-0">
                  <div className="rounded-lg overflow-hidden border border-white/10" style={{ height: '260px' }}>
                    <iframe
                      src="https://maps.google.com/maps?q=401+W+Atlantic+Ave+%23351,+Delray+Beach,+FL+33444&t=&z=15&ie=UTF8&iwloc=&output=embed"
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Fast Passport Center Delray Beach Office Location"
                      aria-label="Google Map showing Fast Passport Center Delray Beach office at 401 W Atlantic Ave Suite 351"
                    />
                  </div>
                  <p className="text-white/40 text-xs mt-2 text-center">
                    401 W Atlantic Ave #351, Delray Beach, FL 33444
                  </p>
                </div>
              </div>
            </div>

            {/* How FPC Helps */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-white rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Cities We Serve + Trust strip */}
          <div>
            <div className="bg-white rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Cities &amp; Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-[#F7F8FA] rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Monroe County and the Florida Keys — start online, ship overnight, and we handle the rest. As a registered courier, we have guaranteed submission availability at the Miami Passport Agency.
              </p>
            </div>

            {/* Internal links */}
            <div className="bg-white rounded-lg p-5 mb-6 border border-gray-200">
              <p className="text-gray-400 text-xs font-semibold uppercase tracking-widest mb-3">Nearby Cities We Serve</p>
              <div className="flex flex-wrap gap-2">
                {[
                  { name: "Key West", href: "/key-west" },
                  { name: "Key Largo", href: "/key-largo" },
                  { name: "Miami", href: "/miami" },
                  { name: "Marathon", href: "/states/florida" },
                  { name: "Naples", href: "/naples" },
                  { name: "Fort Myers", href: "/fort-myers" },
                ].map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-[#F7F8FA] border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                  >
                    {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Trust credentials strip */}
            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}